<form class="w-100 h-100 form" [formGroup]="textForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Editar texto de sección</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Texto</mat-label>
        <textarea style="height: 100px" matInput placeholder="Texto " formControlName="name" required> </textarea>
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
  </div>


  <button class="vs-btn-blue" type="submit" [disabled]="textForm.invalid">
    Guardar
  </button>

</form>
